// Common Constants
const REGEX = {
  FULL_DATE_REGEX: /^(January|February|March|April|May|June|July|August|September|October|November|December) \d{1,2}, \d{4}$/
};

// Report specific Constants
const MAX_METRIC_COUNT = 5;
const MAX_GROUPBY_COUNT = 2;

const COMMON_COLOR = [
  '#5959FF',
  '#FF5959',
  '#59C8FF',
  '#738195',
  '#59FFB0',
  '#AC59FF',
  '#59FFF5',
  '#FF59FF'
];
const COLORS = {
  common: COMMON_COLOR,
  custom: ['#8CBE62', '#084AAE', ...COMMON_COLOR],
  pie: [
    '#5959FF',
    '#FFEF59',
    '#FF5959',
    '#59C8FF',
    '#738195',
    '#59FFB0',
    '#AC59FF',
    '#59FFF5',
    '#FF59FF',
    '#FFB359',
    '#8080FF',
    '#FF8080',
    '#80D5FF',
    '#B9C0CA',
    '#80FFC2',
    '#FF80FF',
    '#BF80FF',
    '#80FFF7',
    '#FFC580'
  ]
};

const GROUPBY_UNITS = [
  { value: 'DAY_OF_WEEK', label: 'reports.chart.config.groupByUnit.dayofweek' },
  {
    value: 'DAY_OF_MONTH',
    label: 'reports.chart.config.groupByUnit.dayofmonth'
  },
  {
    value: 'DAY_MONTH_YEAR',
    label: 'reports.chart.config.groupByUnit.daymonthyear'
  },
  { value: 'WEEK', label: 'reports.chart.config.groupByUnit.week' },
  {
    value: 'MONTH_OF_YEAR',
    label: 'reports.chart.config.groupByUnit.monthofyear'
  },
  {
    value: 'YEAR_MONTH',
    label: 'reports.chart.config.groupByUnit.yearMonth'
  },
  { value: 'QUARTER', label: 'reports.chart.config.groupByUnit.quarter' },
  { value: 'YEAR', label: 'reports.chart.config.groupByUnit.year' }
];

const REMOVECREATETIMEENT = [
  'DataBackupHealth',
  'AntiVirusHealth',
  'PatchHealth',
  'AssetSoftwareInventory',
  'AllAssets'
];

const MODIFYCREATEDTIMEENT = [
  'WorkStation',
  'OfferedItem',
  'Invoice',
  'AssetPatchDetail',
  'HoursWorklogEntry',
  'ClientResourceEfficiency',
  'AssetRemoteSession'
];
const MODIFYCLIENTNAMEENT = [
  'WorkStation',
  'AssetSoftwareInventory',
  'Alert',
  'AssetPatchDetail',
  'FeedbackSurveyResponse',
  'AssetRemoteSession'
];
const MODIFYSITENAMEENT = ['WorkStation'];

const FILTERDATEMAP = {
  WorkStation: 'registeredTime',
  OfferedItem: 'billDate',
  HoursWorklogEntry: 'billDate',
  Invoice: 'invoiceDate',
  AssetPatchDetail: 'installationTime',
  ClientResourceEfficiency: 'computedDate',
  AssetRemoteSession: 'sessionStartTime'
};

const FILTERCLIENTMAP = {
  AssetSoftwareInventory: 'workStation.baseFields.client.accountId',
  Alert: 'workStation.baseFields.client.accountId',
  WorkStation: 'baseFields.client.accountId',
  AssetPatchDetail: 'asset.client.accountId',
  FeedbackSurveyResponse: 'ticket.client.accountId',
  AssetRemoteSession: 'asset.client.accountId'
};

const FILTERSITETMAP = {
  AssetSoftwareInventory: 'workStation.baseFields.site.id',
  Alert: 'workStation.baseFields.site.id',
  WorkStation: 'baseFields.site.id'
};

const MODULEMAP = {
  Ticket: 'ticket',
  WorkStation: 'asset-view',
  Alert: 'alert',
  PatchDetail: 'patch',
  PatchHealth: 'asset-view',
  AntiVirusHealth: 'asset-view',
  DataBackupHealth: 'asset-view',
  Invoice: 'invoice',
  AssetSoftwareInventory: 'AssetSoftwareInventory',
  OfferedItem: 'offered-item',
  AssetPatchDetail: 'AssetPatchDetail',
  Client: 'Client',
  RequesterAssociation: 'RequesterAssociation',
  HoursWorklogEntry: 'hoursworklogentry',
  FeedbackSurveyResponse: 'FeedbackSurveyResponse',
  AssetRemoteSession: 'AssetRemoteSession',
  NMAsset: 'nmasset',
  AllAssets: 'allassets'
};

const BLACKLISTED_ENTITIES = [
  'AssetSoftwareInventory',
  'DataBackupHealth',
  'AntiVirusHealth',
  'PatchHealth'
];

const DATA_REPORT_TABLE = 'REPORTDATATABLE';

const PDF_WIDTH = 1240;
const PDF_HEIGHT = 1754;

const GRAPH_WIDTH = 1000;
const GRAPH_HEIGHT = 600;

const PDF_GUTTER = {
  left_margin: 30,
  top_margin: 20,
  header_height: 35,
  header_top: 15
};
//   DAY_OF_WEEK  # MONDAY, ...,SUNDAY
//   DAY_OF_MONTH # 1,2,3,....,31
//   WEEK # week with year like June 06, 2021
// 	 MONTH_OF_YEAR # JANUARY, ..., DECEMBER
//   QUARTER # 1,2,3,4
//   YEAR

// CHART TYPES
const PIE = 'PIE';
const DOUGHNUT = 'DOUGHNUT';
const VERTICAL_BAR = 'VERTICAL_BAR';
const HORIZONTAL_BAR = 'HORIZONTAL_BAR';
const LINE = 'LINE';
const STACKED_VERTICAL_BAR = 'STACKED_VERTICAL_BAR';
const STACKED_HORIZONTAL_BAR = 'STACKED_HORIZONTAL_BAR';
const GROUPED_VERTICAL_BAR = 'GROUPED_VERTICAL_BAR';
const GROUPED_HORIZONTAL_BAR = 'GROUPED_HORIZONTAL_BAR';
const MULTILINE = 'MULTILINE';
const STACKED_AREA = 'STACKED_AREA';
const NUMBER = 'NUMBER';
const SUMMARY_TABLE = 'SUMMARY_TABLE';
const SITE = 'SITE';
const DEPARTMENT = 'DEPARTMENT';

// Chart options
const ENABLE_TOOLTIP = true;
const ENABLE_LEGEND = false;
const ENABLE_ZOOM = false;
const ENABLE_SPLITLINE = true;

// Chart Sub Types
const NUMBER_CHART = {
  SUB_TYPE: {
    BUTTON: 'button'
  }
};

export {
  MAX_GROUPBY_COUNT,
  MAX_METRIC_COUNT,
  GROUPBY_UNITS,
  PIE,
  DOUGHNUT,
  VERTICAL_BAR,
  HORIZONTAL_BAR,
  LINE,
  STACKED_VERTICAL_BAR,
  STACKED_HORIZONTAL_BAR,
  GROUPED_VERTICAL_BAR,
  GROUPED_HORIZONTAL_BAR,
  MULTILINE,
  STACKED_AREA,
  NUMBER,
  COLORS,
  SUMMARY_TABLE,
  ENABLE_TOOLTIP,
  ENABLE_LEGEND,
  ENABLE_ZOOM,
  PDF_WIDTH,
  PDF_HEIGHT,
  GRAPH_WIDTH,
  GRAPH_HEIGHT,
  PDF_GUTTER,
  REMOVECREATETIMEENT,
  MODIFYCREATEDTIMEENT,
  MODIFYCLIENTNAMEENT,
  FILTERDATEMAP,
  MODULEMAP,
  FILTERCLIENTMAP,
  FILTERSITETMAP,
  DATA_REPORT_TABLE,
  MODIFYSITENAMEENT,
  ENABLE_SPLITLINE,
  DEPARTMENT,
  SITE,
  REGEX,
  NUMBER_CHART,
  BLACKLISTED_ENTITIES
};
